export function isString(str) {
  return typeof str === "string"
}

export function isEmptyString(str) {
  return isString(str) && str.trim().length === 0
}

export function isNonEmptyString(str) {
  return isString(str) && str.trim().length > 0
}
